import PreviewImage from './PreviewImage'

export default PreviewImage
